import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnInit,
  ViewChild,
} from "@angular/core";
import { Router } from "@angular/router";
import { NavigationElement } from "../../../edtell-admin/interfaces/navigation-element.interface";
import { StickyHeaderService } from "../../services/sticky-header.service";

@Component({
  selector: "app-navigation-link",
  templateUrl: "./navigation-link.component.html",
  styleUrls: ["./navigation-link.component.scss"],
})
export class NavigationLinkComponent implements OnInit, AfterViewInit {
  @Input() navElm: NavigationElement;
  @Input() index: number;
  @Input() parent: NavigationLinkComponent;
  @ViewChild("subDropdown", { static: false }) subDropdownElm: ElementRef;
  @ViewChild("dropdown", { static: false }) dropdownElm: ElementRef;
  subDropdownMenu: HTMLElement;
  dropdownMenu: HTMLElement;
  hasParent = true;
  hasChild = true;
  dataloaded = false;
  showDropdown = true;
  sticky = false;

  constructor(
    private router: Router,
    private stickyHeaderService: StickyHeaderService,
  ) {}

  ngOnInit() {
    if (this.navElm.parentElementId == 0) {
      this.hasParent = false;
    }
    if (this.navElm.children.length == 0) {
      this.hasChild = false;
    }
    this.dataloaded = true;
  }

  ngAfterViewInit() {
    if (this.subDropdownElm != undefined) {
      this.subDropdownMenu =
        this.subDropdownElm.nativeElement.children[1].children[0];
    }
    if (this.dropdownElm != undefined) {
      this.dropdownMenu = this.dropdownElm.nativeElement.children[1];
    }
  }

  isURL(item): boolean {
    if (item !== null && (item.startsWith("http") || item.startsWith("www"))) {
      return true;
    } else {
      return false;
    }
  }

  // Helper method to determine if the element is a divider or not
  isDivider(item): boolean {
    if (item.name == "divider") {
      return true;
    } else {
      return false;
    }
  }

  toArray(bar) {
    return Object.keys(bar).map((key) => bar[key]);
  }

  openSubMenu(): void {
    this.subDropdownMenu["style"].display = "block";
  }

  closeSubMenu(): void {
    if (!this.sticky) {
      try {
        this.subDropdownMenu["style"].display = "none";
      } catch {
        // acceptable failure
      }
    }
  }

  openMenu(): void {
    this.dropdownMenu["style"].display = "block";
  }

  closeMenuOnClick(elm: NavigationElement): void {
    if (elm.children.length == 0) {
      this.dropdownMenu["style"].display = "none";
    }
  }

  closeSubMenuOnClick(elm: NavigationElement): void {
    if (elm.children.length == 0) {
      this.subDropdownMenu["style"].display = "none";
    }
  }
  closeMenu(): void {
    if (!this.sticky) {
      try {
        this.dropdownMenu["style"].display = "none";
      } catch {
        // acceptable failure
      }
    }
  }

  navigate(navElm: NavigationElement) {
    this.router.navigate([navElm.url]);
  }

  // called in the sticky header service. should not be called in this component
  setNotSticky() {
    this.sticky = false;
    this.closeMenu();
    this.closeSubMenu();
  }

  // called in the sticky header service. should not be called in this component
  setSticky() {
    this.sticky = true;
  }

  toggleSticky() {
    this.stickyHeaderService.handleSticky(this);
  }
}
